"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPaypalToApiAddress = void 0;
const getCountryAndProvince_1 = require("../utils/getCountryAndProvince");
function formatPaypalToApiAddress(address, firstName = '', lastName = '', phone = '') {
    const { city, country_code, state, postal_code } = (address || {});
    const { address_line_1, address_line_2, admin_area_1, admin_area_2 } = (address || {});
    const provinceKey = state || admin_area_1;
    const addressCity = city || admin_area_2;
    const { country, province } = (0, getCountryAndProvince_1.getCountryAndProvince)(country_code || '', provinceKey || '');
    return {
        address_line_1: address_line_1 || '',
        address_line_2: address_line_2 || '',
        business_name: '',
        city: addressCity || '',
        country: (country === null || country === void 0 ? void 0 : country.name) || '',
        country_code: (country === null || country === void 0 ? void 0 : country.iso_code) || '',
        first_name: firstName,
        last_name: lastName,
        phone_number: phone,
        postal_code: postal_code || '',
        province: (province === null || province === void 0 ? void 0 : province.name) || '',
        province_code: (province === null || province === void 0 ? void 0 : province.iso_code) || ''
    };
}
exports.formatPaypalToApiAddress = formatPaypalToApiAddress;
